module.exports = __webpack_public_path__ + "img/image-not-found.303fed8a.svg";